import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getBrandLogo } from "../styles/branding";
import { useBrandAppearance } from "../hooks/useBrandAppearance";

const PhysicalKey: React.FC = () => {
    const { colors: BrandColors, isDark } = useBrandAppearance();
    const logo = getBrandLogo(isDark ? "dark" : "light");
    // const [isBeforeNoon, setIsBeforeNoon] = useState(true);

    // useEffect(() => {
    //     const now = new Date();
    //     const hours = now.getHours();
    //     setIsBeforeNoon(hours < 12);
    // }, []);

    const { t } = useTranslation("check_in_complete");

    return (
        <Box sx={{ textAlign: "center", marginTop: "4rem" }}>
            {/* Key Card Image */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                    backgroundColor: BrandColors.physicalKey,
                    width: "131px",
                    height: "202px",
                    mx: "auto",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                }}
            >
                <img src={logo} alt="KeycardLogo" width={90} />
                <Typography variant="body1" sx={{ mt: 4, fontSize: "14px", fontWeight: "bold", color: BrandColors.physicalKeyText }}>
                    {t("keycard")}
                </Typography>
            </Box>

            {/* Status Message */}
            <Box sx={{ marginTop: "4rem", maxWidth: "450px", mx: "auto" }}>
                <Typography variant="body1">
                    {t("keycardNote")}
                </Typography>
            </Box>

            {/* Request Key Button */}
            {/* <Button
                variant="contained"
                disabled={!isBeforeNoon}
                sx={{
                    mt: 2,
                    backgroundColor: isBeforeNoon ? "#7C624B" : "#E0D8CC",
                    color: isBeforeNoon ? "#FFFFFF" : "#A4957E",
                    fontWeight: "bold",
                    borderRadius: "0px",
                    width: "290px",
                    height: "80px",
                    gap: 1, // Space between icon and text
                    "&:hover": { backgroundColor: isBeforeNoon ? "#A4957E" : "#E0D8CC" },
                }}
            >
                <Box
                    component="img"
                    src={KeycardIcon}
                    alt="Key Card Icon"
                    sx={{
                        width: 32,
                        height: 32,
                        filter: isBeforeNoon ? "none" : "brightness(0.6)",
                    }}
                />
                {isBeforeNoon ? "REQUEST KEY-CARD" : "KEY-CARD REQUESTED"}
            </Button> */}
        </Box>
    );
};

export default PhysicalKey;
